const o = new URL("../../assets/icon-goto-lootrush-CMR2v0PF.png", import.meta.url).href;
export {
  o as default
};
//# sourceMappingURL=icon-goto-lootrush.png.js.map
